import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { SettingsPageMetadata } from '@/shared';

const securityTabTitles: Record<string, string> = {
    events: 'Event Streaming',
    logs: 'Audit Logs',
    overview: 'Overview',
    retention: 'Data Retention',
};

const Metadata: FC = () => {
    const location = useLocation();
    const activeTab = location.pathname.split('/')[4] ?? 'overview';
    const activeTabTitle = securityTabTitles[activeTab];

    return (
        <SettingsPageMetadata
            scope='Workspace'
            segments={activeTabTitle && activeTab !== 'overview' ? [activeTabTitle, 'Security'] : ['Security']}
        />
    );
};

export default Metadata;
